var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-filter"},[_c('main-filter-component',{attrs:{"type":`${_vm.$route.params.type}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }